<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="dialogVisible" persistent max-width="420">
      <v-card
        class="pa-4"
      >
        <v-container fluid>
          <v-row justify="center" align-content="center">
            <v-progress-circular
              :size="170"
              :width="7"
              color="primary"
              :value="(timerCount / $store.state.remoteConfig.authorizationTimeoutSecs) *100"
            >
              <span class="black--text text--primary"> {{ $t('dialog.request.timeLeft') }} {{ mintesAndSeconds }}</span>
            </v-progress-circular>
            <!-- TODO: megcsinalni rendesen figma szerint es szopni az animationokkel + "Szellemképes" -->
          </v-row>
          <v-row justify="center" align-content="center">
            <div class="text-center mt-6 ma-2">
              {{ $t('dialog.request.requestAuthorization') }}
            </div>
            <div v-if="evroSignatureCount > 1" class="text-center ma-2">
              <span>{{ $t('dialog.request.evroSignatureCount', {signatureCount: evroSignatureCount}) }}</span>
            </div>
            <div class="text-center caption">
              <span>{{ $t('dialog.request.requestId') }} <br> <span class="primary--text font-italic">{{ signatureGuid }}</span> <br> {{ $t('dialog.request.shouldMatchIds') }}</span>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    signatureGuid: {
      type: String,
      default: 'matching-guid'
    },
    evroSignatureCount: {
      type: Number,
      default: 0
    },
    requestLoadingDialogShowed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialogVisible: this.requestLoadingDialogShowed,
      timerCount: this.$store.state.remoteConfig.authorizationTimeoutSecs
    }
  },
  computed: {
    mintesAndSeconds() {
      const minutes = Math.floor(this.timerCount / 60)
      const seconds = this.timerCount - minutes * 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        }
      },
      immediate: true
    },
    requestLoadingDialogShowed: function(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  }

}
</script>

<style scoped>
.sic-modal-btn{
  position: relative;
  left: 90%;
  top: 10%;
}
</style>
